import type { ReadonlyDeep } from 'type-fest'

import { getEnumValuesFromPipelineSchema } from '@flows/configs/shared/schemaUtils'
import type { TranslationKey } from '@flows/core/i18n/types'
import type { AnyCallbackConfig } from '@flows/core/types/dispatchedHookTypes'
import type { HarmonyTitle, InfoBox } from '@flows/core/types/stepContentTypes'
import type { AnySimpleOnSubmitHook } from '@flows/core/types/stepTypes'
import { BaseSchema_LiabilityV1GetsafeDe as schema } from '@flows/insurance/schemas'
import { getClaimsOptions } from '@flows/insurance/utils/stepContentUtils'
import type { getChoiceOptions } from '@flows/insurance/utils/stepContentUtils'

// Needs to be a function so it can be a generic

const claimsOptionsFromSchema = getEnumValuesFromPipelineSchema(
  schema.shape.number_of_claims_in_last_5y.unwrap()
)

export const LIABILITY_CONSTANTS: {
  deductiblesOptions: string[]
  claimsOptions: ReturnType<typeof getChoiceOptions>
} = {
  deductiblesOptions: ['0', '150', '300'],
  claimsOptions: getClaimsOptions(claimsOptionsFromSchema.length, true),
}

type DeductibleData = {
  title?: TranslationKey
  modalTitle?: TranslationKey
  modalInfo?: TranslationKey
}

// Needs to be a function, so it can be a generic
export const DEDUCTIBLE_HEADER = (data?: DeductibleData) =>
  ({
    type: 'harmonyTitle',
    text: {
      type: 'translatableText',
      translationKey: data?.title || 'sharedFlows_common:steps.deductibles',
    },
    infoButton: {
      modalConfiguration: [
        {
          type: 'title',
          text: {
            type: 'translatableText',
            translationKey: data?.modalTitle || 'sharedFlows_common:generic.deductible.title',
          },
        },
        {
          type: 'text',
          text: {
            type: 'translatableText',
            translationKey: data?.modalInfo || 'sharedFlows_common:generic.deductible.info',
          },
        },
      ],
    },
  }) satisfies HarmonyTitle<undefined, AnyCallbackConfig, AnySimpleOnSubmitHook>

type DeductibleInfoProps = {
  title?: TranslationKey
  text?: TranslationKey
}

// Needs to be a function, so it can be a generic
export const DEDUCTIBLE_INFO = (infoProps?: DeductibleInfoProps) =>
  ({
    type: 'infoBox',
    contentConfiguration: [
      {
        type: 'title',
        isSmall: true,
        text: {
          type: 'translatableText',
          translationKey: infoProps?.title || 'sharedFlows_common:generic.deductible.info.title',
        },
      },
      {
        type: 'text',
        text: {
          type: 'translatableText',
          translationKey: infoProps?.text || 'sharedFlows_common:generic.deductible.info',
        },
      },
    ],
  }) satisfies ReadonlyDeep<InfoBox<undefined, AnyCallbackConfig, AnySimpleOnSubmitHook>>
